import { ReactNode, useState } from "react";
import CaseBlockTitle from "../../common/case-block-title/case-block-title";
import iCaretDown from "../../../assets/icons/caret-down.svg";
import { getAssetUrl } from "../../../api/api";
import type { TCaseReviewAuthor, TCaseReviewLogo } from "../../../types/types";
import "./cases-review-block.sass";

type Props = {
  children: ReactNode;
  author?: TCaseReviewAuthor;
  title?: string;
  logo?: TCaseReviewLogo;
};

const CasesReviewBlock = ({ children, author, title, logo }: Props) => {
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div className="cases-review-block">
      <div className="cases-review-block__content">
        <CaseBlockTitle>{title}</CaseBlockTitle>

        <div className="cases-review-block__text">
          <div
            className={
              !isOpen
                ? "cases-review-block__review"
                : "cases-review-block__review-open"
            }
          >
            {children}
          </div>

          {!isOpen && (
            <div className="cases-review-block__btn" onClick={handleOpen}>
              Читать отзыв полностью
              <img
                src={iCaretDown}
                className="cases-review-block__caret"
                alt=""
              />
            </div>
          )}
        </div>

        <div className="cases-review-block__client">
          <img
            src={getAssetUrl(
              author?.image?.url ? author.image.url : "",
            )}
            className="cases-review-block__client-avatar"
            alt=""
          />

          <div className="cases-review-block__client-name">
            {author?.name ?? "Иван Иванович, CMO/ Маркетинг директор"}
          </div>
        </div>

        <img
          src={getAssetUrl(logo?.url ? logo.url : "")}
          className="img-absolute cases-review-block__client-logo"
          alt="logo"
        />
      </div>
    </div>
  );
};

export default CasesReviewBlock;
